import React from 'react';

import {
  useBulkAddDocumentsToTeam,
  useBulkRemoveDocumentsFromTeam,
  useTeams,
} from 'app/teams/api';
import {convertLocationParamsToFetchParams} from 'app/teams/utils';

import {AddToTeamPopover} from './AddToTeamPopover';

import type {OverlayProps} from 'app/general/overlays';

interface Props {
  overlayProps: OverlayProps;
  documentURLs: Array<string>;
  documentObjectURLs: Array<string>;
  onSuccess: () => Promise<unknown>;
}

export const AddDocumentsToTeamPopover = ({
  overlayProps,
  documentURLs,
  documentObjectURLs,
  onSuccess,
}: Props) => {
  const {data: attached} = useTeams(
    convertLocationParamsToFetchParams({
      document_url: documentObjectURLs.join(','),
    }),
    {refetchOnMountOrArgChange: false}
  );

  const [addDocumentsToTeam] = useBulkAddDocumentsToTeam();
  const [removeDocumentsFromTeam] = useBulkRemoveDocumentsFromTeam();

  return (
    <AddToTeamPopover
      overlayProps={overlayProps}
      attached={attached?.results}
      itemURL={''}
      onSuccess={onSuccess}
      addItemToTeam={(team) => {
        return addDocumentsToTeam({
          team: team.url,
          documents: documentURLs,
        }).unwrap();
      }}
      removeItemsFromTeam={(team) => {
        return removeDocumentsFromTeam({
          team: team.url,
          documents: documentURLs,
        }).unwrap();
      }}
      getTeamFilterParams={() => null}
    />
  );
};
